
var TECL_HelpMessage = {

    // Display the helpe messaging dialog
    DisplayHelpMessageDialog: function(tenderId, tenderName, tenderSupplierId, supplierName, messageType) {

        if (TECL_Master.AddLock("TECL_HelpMessage_DisplayHelpMessageDialog")) {

            $.ajax({
                url: baseSiteUrl + "TenderUserSurface/GetUserMessageDialog",
                type: "POST",
                data: {
                    tenderId: tenderId,
                    tenderName: tenderName,
                    tenderSupplierId: tenderSupplierId,
                    supplierName: supplierName,
                    messageType: messageType
                },
                error: function() {
                    TECL_Master.ClearLock("TECL_HelpMessage_DisplayHelpMessageDialog");
                    TECL_Master.ShowErrorDialog();
                },
                success: function(view) {
                    TECL_Master.ClearLock("TECL_HelpMessage_DisplayHelpMessageDialog");

                    if (view) {
                        if (messageType == "supplier_rejection") {
                            $("#lastSupplierRejectionDialog").modal("hide");
                        }

                        $("#helpMessageDialogDiv").html(view);
                        $("#helpMessageDialog").modal("show");
                    } else {
                        TECL_Master.ShowErrorDialog();
                    }
                }
            });
        }
    },

    // Send help message
    SendHelpMessage: function(tenderId, tenderName, tenderSupplierId, supplierName, messageType) {
        if (tenderId && TECL_HelpMessage.ValidateDialog()) {
            var message = TECL_HelpMessage.GetMessage();

            if (TECL_Master.AddLock("TECL_HelpMessage_SendHelpMessage")) {
                $.ajax({
                    url: baseSiteUrl + "TenderUserSurface/SendRejectionHelpRequestEmail",
                    type: "POST",
                    data: {
                        tenderId: tenderId,
                        tenderName: tenderName,
                        supplierTenderId: tenderSupplierId,
                        supplierName: supplierName,
                        messageType: messageType,
                        userMessage: message
                    },
                    error: function() {
                        TECL_Master.ClearLock("TECL_HelpMessage_SendHelpMessage");
                        TECL_Master.ShowErrorDialog();
                    },
                    success: function(sent) {
                        TECL_Master.ClearLock("TECL_HelpMessage_SendHelpMessage");

                        if (sent) {
                            $("#helpMessageDialog").modal("hide");
                            TECL_Master.DisplayNoticeDlg("Help message sent");
                        } else {
                            TECL_Master.ShowErrorDialog("Failed to send the help message");
                        }
                    }
                });
            }
        }
    },

    // Validate rejection selections
    ValidateDialog: function() {
        var isValid;
        var message = TECL_HelpMessage.GetMessage();

        if (message && message.length > 0) {
            isValid = true;
        } else {
            dialog.find("[name=noHelpMessageErr]").removeClass("hidden");
            isValid = false;
        }
        return isValid;
    },

    // Validate rejection selections
    GetMessage: function() {
        var message = null;
        var dialog = $("#helpMessageDialog");

        if (dialog) {
            dialog.find("[name=noHelpMessageErr]").addClass("hidden");
            message = dialog.find(".helpMessage").val();
        }
        return message;
    }

}